import React, { useState } from 'react';
import classes from "./waiver.module.css";
import InputField from "../../../containers/inputField/inputField";
import DoubleArrow from "../../../../assets/images/red-arrow.png";
import WhiteArrow from "../../../../assets/images/double-arrow.png";
import SignedDocument from "./signedDocument";
import { sixYardAxios } from '../../../../sixYardAxios';
import PromptMessage from '../../../containers/promptMessage/promptMessage';

const Waiver = (props) => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [name, setName] = useState("");
    const [address, setAddress] = useState("");
    const [email, setEmail] = useState("");
    const [kids, setKids] = useState([]);
    const [signature, setSignature] = useState("");
    // const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [reference, setReference] = useState([]);
    const [referenceDetails, setReferenceDetails] = useState({
        details: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "Enter family / friend name or other",
            },
            value: "",
            validation: {
                required: true,
                minLength: 6,
                maxLength: 32,
            },
            label: "Specify Details",
            valid: false,
            touched: false
        }
    });
    const handleCheckboxChange = (id) => {
        setReference((prevReference) => {
            if (prevReference.includes(id)) {
                return prevReference.filter((referenceId) => referenceId !== id);
            } else {
                return [...prevReference, id];
            }
        });
    };
    const inputChangedHandler = (event) => {
        const updatedControls = {
            ...referenceDetails,
            details: {
                ...referenceDetails.details,
                value: event.target.value,
                // valid: checkValidity(event.target.value, referenceDetails.details.validation),
                touched: true
            }
        };
        setReferenceDetails(updatedControls);
    };
    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                registration_id: props.registrationId,
                guardian_name: name,
                guardian_address: address,
                guardian_email: email,
                participants_names: kids,
                signature: signature,
                reference_source: reference.length > 1 ? reference.join(', ') : reference[0].toLowerCase(),
                reference_details: referenceDetails.details.value
            }
            const response = await sixYardAxios.post('/camps/waiver', formData);
            if (response.data.data) {
                props.setPaymentData(response.data.data);
                localStorage.setItem("campRegistrationFormWaiver", JSON.stringify(formData))
                   props.setCurrentStep(props.currentStep + 1);
                   window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (err) {            
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const backHandler = () => {
        props.setCurrentStep(props.currentStep - 1)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    const referenceList = [
        {
            id: 1,
            label: 'Facebook'
        },
        {
            id: 2,
            label: 'Instagram'
        },
        {
            id: 3,
            label: 'LinkedIn'
        },
        {
            id: 4,
            label: 'Google Search'
        },
        {
            id: 5,
            label: 'Family or Friend'
        },
        {
            id: 6,
            label: 'Other'
        },
    ]
    return (
        <>
            <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
                <SignedDocument setName={setName} setAddress={setAddress} setEmail={setEmail} 
                kids={kids} setKids={setKids} setSignature={setSignature}/>
                <div>
                    <div className={classes.TextDeclarationTitle}>How did you hear about us</div>
                    <div>{referenceList.map(item =>
                        <div className={classes.CheckBox} key={item.id}>
                            <input type="checkbox"
                                onChange={() => handleCheckboxChange(item.label)}
                                checked={reference.includes(item.label)} />
                            <label className={classes.Label}>
                                {item.label}
                            </label>
                        </div>
                    )}</div>
                    <br />
                    <div className={classes.ReferenceDetails}>
                        <InputField
                            elementType={referenceDetails.details.elementType}
                            elementConfig={referenceDetails.details.elementConfig}
                            value={referenceDetails.details.value}
                            invalid={!referenceDetails.details.valid}
                            shouldValidate={referenceDetails.details.validation}
                            touched={referenceDetails.details.touched}
                            label={referenceDetails.details.label}
                            disabled={(reference.includes("Other") || reference.includes("Family or Friend")) ? false : true}
                            changed={event => inputChangedHandler(event)}
                        />
                    </div>
                </div>
                <div className={classes.Buttons}>
                    <button onClick={backHandler}>
                        <img
                            src={DoubleArrow}
                            alt=""
                            className={classes.Icon}
                        /> BACK
                    </button>
                    <button type='submit'
                        className={[classes.Next /*, !isTermsChecked && classes.Disabled*/].join(" ")}
                        // disabled={!isTermsChecked}
                        >
                        NEXT <img
                            src={WhiteArrow}
                            alt=""
                            className={classes.Icon}
                        />
                    </button>
                </div>
            </form>
            {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
        </>
    )
}
export default Waiver;